export const defaultStyles = {
  color: "var(--theme-website-color-text-primary)",
  fontWeight: "500",
  fontSize: "1",
  lineHeight: "1.5",
  textTransform: "none",
  fontStyle: "normal",
  textDecoration: "none",
  textAlign: "left",
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "24",
    paddingRight: "0",
  },
  borderColor: "var(--theme-website-color-border-primary)",
} as const;
